import { STORAGE_UNIT_SIZE } from '../../app.constants';

export const MULTIPART_CONCURRENCY = 4;
export const FILES_CONCURRENCY = 4;
export const RETRY_COUNT = 3;
export const RETRY_DELAY = 1000; // in milliseconds
export const CHUNK_SIZE = 10 * STORAGE_UNIT_SIZE * STORAGE_UNIT_SIZE; // size of each chunk (10MB)
export const DICOM_ACQUISITION_ERROR = 'Acquisition failure - a dicom file in this folder failed to be parsed or de-identified'
export const TIME_UPDATE_INTERVAL = 2000;
